import React, {Fragment, useEffect, useRef, useState} from "react";
import Translate from "localization/Translate";
import {validateEmail, validatePhone} from "../../redux/dto/customer";
import Button from "../../buttons/Button";
import {useDispatch, useSelector} from "react-redux";
import {
    closeRightPanelDialogue,
    createMember,
    findCustomerByAdditionalInfo,
    openModal,
    setKeyboard,
    setLoading,
    setMemberMarketingConsent
} from "../../redux/actions";
import {getAccountCreationFieldsConf, getCountryDialCode, getReceiptLanguage} from "../../redux/selectors";
import CheckBox from "../../formElements/CheckBox";
import {
    PerfectScrollbarWithHotfix as PerfectScrollbar
} from "../../uiComponents/WrappedPerfectScrollBar";
import CloseButton from "../../buttons/CloseButton";
import PhoneInput from "./PhoneInput";
import {getTranslate} from "../../localization/localizeSlice";
import {
    CREATE_ACCOUNT_FAILED,
    CREATE_ACCOUNT_OPENED,
    CREATE_ACCOUNT_SUBMITTED
} from "../../redux/actionTypes";

const getTerms = (type, lang) => {
    let terms = window.AppConf[`${type}_${lang}`];
    if(typeof terms === "undefined" || terms === ""){
        terms = window.AppConf[type] ?? false;
    }
    return terms === "" ? false : terms;
}

const validateField = (field, value) => {
    if((field?.validationRegex ?? "") !== "") {
        return value.match(new RegExp(field.validationRegex));
    }else {
        let validationFunction = eval(field?.validationFunction ?? "");
        if(typeof validationFunction !== "undefined") {
            return validationFunction(value);
        }
    }
    return true;
}
const formatField = (field, value) => {
    let formatFunction = eval(field?.formatFunction ?? "");
    if(typeof formatFunction !== "undefined") {
        return formatFunction(value);
    }
    return value;
}

const getFieldError = (field) => {
    let error = field?.validationError ?? "";
    if(error === "") {
        error = "Enter correct value";
    }
    return error;
}

export default function (props) {
    let customer = useSelector(state => state.rootReducer.customer);
    let state = useSelector(state => state);
    let countryCode = useSelector(state => state.rootReducer.erplyConf.DKTCountryCode);
    let connectionHealth = useSelector(state => state.rootReducer.connectionHealth);
    const dispatch = useDispatch();
    let lang = useSelector(state => state.localize.activeLocale);
    let translate = getTranslate(state);
    let inputRefs = useRef({});
    const [validationErrors, setValidationErrors] = useState({});
    const [customerConsentSet, setCustomerConsent] = useState(false);
    const [optInSet, setOptIn] = useState(false);
    const [selectedDialCode, selectDialCode] = useState(countryCode);

    useEffect(() => {
        console.log("Create customer opened");
        dispatch({
            type: CREATE_ACCOUNT_OPENED
        });
        return () => {
            console.log("Create customer closed");
        }
    }, []);

    let inputFieldsConf = getAccountCreationFieldsConf();

    if(customer !== false){
        dispatch(closeRightPanelDialogue());
    }

    let onInputDone = () => {
        let errors = {};
        let values = Object.keys(inputRefs.current).reduce((acc, el) => {
            let value = inputRefs.current[el].value;
            if(el === 'phone' && value !== ""){
                value = '+' + getCountryDialCode(selectedDialCode) + value.replace(/\D/g,'');
            }
            acc[el] = value;
            return acc;
        }, {});

        if(!customerConsentSet){
            errors.consent = "You have to accept the terms of use to proceed!";
        }
        let primarySet = false;
        inputFieldsConf.primary.forEach((field) => {
            let value = values[field.id];
            if(value !== ""){
                primarySet = true;
            }
            if(field.required && value === ""){
                errors[field.id] = `Enter ${field.label}`;
            }
            if(field.id === 'email' && value !== ""){
                if(!validateEmail(value)){
                    errors.email = "emailValidationError";
                }
            }
            if(field.id === 'phone' && value !== ""){
                if(!validatePhone(value)){
                    errors.phone = "phoneValidationError";
                }
            }
        });

        if(!primarySet){
            if(inputFieldsConf.primary.length === 1){
                errors[inputFieldsConf.primary[0].id] = `Enter ${inputFieldsConf.primary[0].label}`;
            }else{
                errors.primary = "Enter one of the primary identifiers";
            }
        }

        inputFieldsConf.secondary.forEach((field) => {
            let value = values[field.id];
            if(field.required && value === ""){
                errors[field.id] = `Enter ${field.label}`;
            }else{
                if(!validateField(field, value)){
                    errors[field.id] = getFieldError(field);
                }
            }
            if(field.id === 'email' && value !== ""){
                if(!validateEmail(value)){
                    errors.email = <Translate id={"emailValidationError"}/>;
                }
            }
            if(field.id === 'phone' && value !== ""){
                if(!validatePhone(value)){
                    errors.phone = <Translate id={"phoneValidationError"}/>;
                }
            }
        });

        let locale = window.AppConf?.memberLocale ?? "";
        if(locale === ""){
            locale = getReceiptLanguage(state) + '-' + state.rootReducer.erplyConf.country;
        }

        let parameters = {
            location: state.rootReducer.erplyConf.DKTCountryCode,
            claims: {
                locale
            },
            additional_information: []
        };

        [...(inputFieldsConf.primary || []),...(inputFieldsConf.secondary || [])].forEach((inputField) => {
            let value = values[inputField.id]
            if(typeof value !== "undefined" && value !== ""){
                if(inputField?.apiField?.type === 'claims'){
                    parameters.claims[inputField.apiField.name] = value;
                }else if(inputField?.apiField?.type === 'additional_information'){
                    parameters.additional_information.push({
                        id: inputField.apiField.name,
                        value,
                        country: state.rootReducer.erplyConf.DKTCountryCode
                    });
                }
            }
        });

        dispatch({
            type: CREATE_ACCOUNT_SUBMITTED,
            payload: {
                ...parameters,
                customerConsentSet,
                optInSet
            }
        });

        setValidationErrors(errors);
        if(Object.keys(errors).length > 0){
            return;
        }

        console.log("createMember", {parameters, optInSet});
        dispatch(setLoading(true));

        let checkUniqueFields = (inputFieldsConf.secondary || []).filter((inputField) => {
            let value = values[inputField.id];
            return inputField?.checkUnique && typeof value !== "undefined" && value !== "";
        });
        let checkUnique = (checkUniqueFields) => {
            return new Promise((resolve, reject) => {
                if(checkUniqueFields.length === 0){
                    resolve();
                    return;
                }
                let inputField = checkUniqueFields.pop();
                let value = values[inputField.id];
                if(inputField?.apiField?.type === 'claims'){
                    checkUnique(checkUniqueFields).then(resolve,reject);
                }else if(inputField?.apiField?.type === 'additional_information'){
                    dispatch(findCustomerByAdditionalInfo({
                        id: inputField.apiField.name,
                        value,
                        country: state.rootReducer.erplyConf.DKTCountryCode
                    }, () => {
                        dispatch(setLoading(false));
                        let error = translate("Customer with this ${label} already exists", {label: inputField.label});
                        setValidationErrors({[inputField.id]: error});
                    }, () => {
                        checkUnique(checkUniqueFields).then(resolve,reject);
                    }, true, true));
                }
            });
        }

        checkUnique(checkUniqueFields).then(() => {
            dispatch(createMember(parameters, state.rootReducer.warehouse.code, (customer) => {
                customer.marketingConsent = optInSet ? "true" : "false";
                console.log("create customer success", {customer});
                if(customer?.rawData?.sub){
                    dispatch(setLoading(false));
                    dispatch(setMemberMarketingConsent(customer.rawData.sub, optInSet));
                }
            }, (response) => {
                console.log("create customer failed", {response});
                dispatch(setLoading(false));
                dispatch({
                    type: CREATE_ACCOUNT_FAILED,
                    payload: {
                        message: response.data.message
                    }
                });
            }));
        });
    }

    useEffect(() => {
        dispatch(setKeyboard(true, onInputDone));
        return () => {
            dispatch(setKeyboard(false));
        }
    }, [validationErrors]);

    let ValidationErrorDisplay = ({validationError, style={}}) => (
        <div className={'errorMessage'} style={{
            fontSize: "1rem",
            textAlign: "left",
            ...style
        }}><Translate id={validationError}/></div>
    );

    let termsOfUse = getTerms("termsOfUse", lang);
    let privacyPolicy = getTerms("privacyPolicy", lang);
    let optInTerms = getTerms("optInTerms", lang);

    let customerConsentEl;
    if(termsOfUse !== false && privacyPolicy !== false){
        let consentVariables = {
            termsOfUse: <a href="#" onClick={(e) => {
                e.preventDefault();
                dispatch(setKeyboard(false));
                dispatch(openModal({
                    content: <PerfectScrollbar>
                        <div dangerouslySetInnerHTML={{__html: termsOfUse}} style={{marginRight: "1.43rem"}}/>
                    </PerfectScrollbar>,
                    className: "Administration",
                    onClose: () => {
                        dispatch(setKeyboard(true, onInputDone));
                    },
                    canClose: true,
                }));
            }}>
                <Translate id={"Terms of Use"}/>
            </a>,
            privacyPolicy: <a href="#" onClick={(e) => {
                e.preventDefault();
                dispatch(setKeyboard(false));
                dispatch(openModal({
                    content: <PerfectScrollbar>
                        <div dangerouslySetInnerHTML={{__html: privacyPolicy}}/>
                    </PerfectScrollbar>,
                    className: "Administration",
                    onClose: () => {
                        dispatch(setKeyboard(true, onInputDone));
                    },
                    canClose: true,
                }));
            }}>
                <Translate id={"Privacy Policy"}/>
            </a>
        }

        customerConsentEl =
            <>
                <div style={{
                    margin: "0.36rem 0",
                    textAlign: "justify"
                }}>
                    <Translate id={"Taking care of your personal data is team work. We will confirm the creation of your account only with your consent"}/>
                </div>
                <div className={"customerConsentBox"}>
                    <CheckBox
                        name="customerConsent"
                        onChange={checked => {
                            setCustomerConsent(checked);
                        }}
                        checked={customerConsentSet}
                    />
                    <span style={{ display: "block", textAlign: "left" }}>
                        <Translate id={'I have read and understood the ${termsOfUse} and the ${privacyPolicy}'} values={consentVariables}/>
                    </span>
                </div>
                { validationErrors.consent ? <ValidationErrorDisplay validationError={validationErrors.consent} /> : ""}
            </>;
    }else{
        if(customerConsentSet === false){
            setCustomerConsent(true);
        }
    }

    let optInEl;
    if(optInTerms !== false){
        optInEl = <>
            <div style={{
                margin: "0.36rem 0",
                textAlign: "justify"
            }}>
                <Translate id={"Do you want to receive your gift vouchers, offers, promotions, news and advice that suit you?"}/>
            </div>
            <div className={"customerConsentBox"}>
                <CheckBox
                    name="customerConsent"
                    onChange={checked => {
                        setOptIn(checked);
                    }}
                    checked={optInSet}
                />
                <span style={{ display: "block", textAlign: "left" }}>
                        <Translate id={'OPT IN, I have read and understood the ${termsOfUse}'} values={{
                            termsOfUse: <a href="#" onClick={(e) => {
                                e.preventDefault();
                                dispatch(setKeyboard(false));
                                dispatch(openModal({
                                    content: <PerfectScrollbar>
                                        <div dangerouslySetInnerHTML={{__html: optInTerms}}/>
                                    </PerfectScrollbar>,
                                    className: "Administration",
                                    onClose: () => {
                                        dispatch(setKeyboard(true, onInputDone));
                                    },
                                    canClose: true,
                                }));
                            }}>
                                <Translate id={"Opt In Terms of Use"}/>
                            </a>
                        }}/>
                    </span>
            </div>
        </>
    }

    if(connectionHealth){
        let firstField = inputFieldsConf.primary.find(el => el?.order === "1") ??
            inputFieldsConf.secondary.find(el => el?.order === "1") ??
            inputFieldsConf.primary?.[0] ?? {id:"missing"};
        return (
            <div style={{
                marginTop: "-2.86rem",
                fontSize: "1.14rem",
                textAlign: "left"
            }}>
                <CloseButton style={{
                    position: "relative",
                    left: "0.71rem",
                    top: "3.71rem"
                }} onClose={props.onBack}/>
                <PerfectScrollbar style={{
                    position: "absolute",
                    left: "0",
                    right: "0",
                    height: "calc(100% - 14rem)"
                }}>
                    <div style={{
                        width: "70%",
                        margin: "0 auto"
                    }}>
                        <span style={{
                            fontSize: '1.3rem'
                        }}>
                            <Translate id={"To create your account fill the following information"}/>
                        </span>
                        <div style={{
                            margin: "0.71rem 0"
                        }}>
                            <Translate id={"Choose how to identify"}/>:
                        </div>
                        <table style={{
                            width: "100%"
                        }}><tbody style={{
                            display: "grid"
                        }}>
                        {inputFieldsConf.primary.map((field, index) => {
                            let separator;
                            if(index !== 0 && (field?.order ?? "") === ""){
                                separator = <tr style={styles.inputRow(field?.order ?? "")}>
                                    <td></td>
                                    <td style={{textAlign:"center"}}>
                                        <Translate id="createCustomerPrimarySeparator"/>
                                    </td>
                                </tr>;
                            }
                            let inputField;
                            if(field.id === 'phone'){
                                inputField = <PhoneInput
                                    style={{marginTop: "0.29rem"}}
                                    inputRef={(el) => inputRefs.current[field.id] = el}
                                    id={field.id}
                                    placeholder={field?.placeholder ?? ""}
                                    selectedDialCode={selectedDialCode}
                                    selectDialCode={selectDialCode}
                                    countryCode={countryCode}
                                    autoFocus={field.id === firstField.id}
                                />;
                            }else{
                                inputField = <input
                                    autoFocus={field.id === firstField.id}
                                    ref={(el) => inputRefs.current[field.id] = el}
                                    type={"text"}
                                    className={"shadowBoxInput"}
                                    style={{
                                        width: "100%",
                                        boxSizing: "border-box"
                                    }}
                                    name={field.id}
                                    autoComplete={"off"}
                                    placeholder={translate(field?.placeholder ?? "")}
                                    data-keyboard-layout={"letters"}
                                />;
                            }
                            return <Fragment key={index}>
                                {separator}
                                <tr style={styles.inputRow(field?.order ?? "")}>
                                    <td><Translate id={field.label}/>{field.required ? '*' : ''}:</td>
                                    <td>{inputField}</td>
                                </tr>
                                <tr style={styles.inputRow(field?.order ?? "")}>
                                    <td></td>
                                    <td>{ validationErrors[field.id] ? <ValidationErrorDisplay validationError={validationErrors[field.id]} /> : ""}</td>
                                </tr>
                            </Fragment>
                        })}
                        <tr>
                            <td></td>
                            <td>{ validationErrors.primary ? <ValidationErrorDisplay validationError={validationErrors.primary} /> : ""}</td>
                        </tr>
                        {inputFieldsConf.secondary.map((field, index) => {
                            return <>
                                <tr style={styles.inputRow(field?.order ?? "")}>
                                    <td><Translate id={field.label}/>{field.required ? '*' : ''}:</td>
                                    <td>
                                        <input
                                            autoFocus={field.id === firstField.id}
                                            ref={(el) => inputRefs.current[field.id] = el}
                                            type={"text"}
                                            className={"shadowBoxInput"}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                            name={field.id}
                                            autoComplete={"off"}
                                            placeholder={translate(field?.placeholder ?? "")}
                                            data-keyboard-layout={"letters"}
                                            onChange={(el) => {
                                                let value = el.target.value;
                                                let errors = {...validationErrors};
                                                let error = getFieldError(field);

                                                value = formatField(field, value);
                                                if(el.target.value !== value) {
                                                    el.target.value = value;
                                                }

                                                if(validateField(field, value)) {
                                                    delete errors[field.id];
                                                    setValidationErrors(errors);
                                                }else {
                                                    errors[field.id] = error;
                                                    setValidationErrors(errors);
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr style={styles.inputRow(field?.order ?? "")}>
                                    <td></td>
                                    <td>{ validationErrors[field.id] ? <ValidationErrorDisplay validationError={validationErrors[field.id]} /> : ""}</td>
                                </tr>
                            </>
                        })}
                        </tbody></table>
                        { customerConsentEl }
                        { optInEl }
                        <Button
                            onClick={onInputDone}
                            type="button"
                            className={"wideButton darkerBlueButton"}
                            name={<Translate id="confirm"/>}
                            style={{
                                display: "block",
                                width: "50%",
                                margin: "0.71rem auto"
                            }}/>
                    </div>
                </PerfectScrollbar>
            </div>
        );
    }else{
        return (
            <>
                <div><Translate id={"System is offline. Account creation not available!"}/></div>
                <div onClick={props.onBack} style={{
                    margin: "0.71rem 2.14rem 0.71rem 0"
                }}>
                    <Button type="button" className={"wideButton grayButton"} name={<Translate id="back"/>}/>
                </div>
            </>
        );
    }
}

const styles = {
    inputRow: (order) => {
        if(order === ""){
            order = "100";
        }
        return {
            order,
            display: "grid",
            gridTemplateColumns: "1fr 50%"
        }
    }
}